export default __webpack_public_path__ + "static/media/product-1.17bba698.webp";